/**
 * Supabase Client - Centralized Singleton
 *
 * This is the single Supabase client instance used across the entire application.
 * All components should import from here instead of creating their own instances.
 *
 * Usage:
 *   import { supabase } from '../lib/supabaseClient';
 *
 * @author AI Agent (OpenClaw)
 * @date February 18, 2026
 */

import { createClient } from '@supabase/supabase-js';

// Get environment variables
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://your-project.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'your-anon-key';

// Validate environment variables
if (process.env.NODE_ENV === 'production' && (!supabaseUrl || supabaseUrl === 'https://your-project.supabase.co')) {
  console.error('❌ Supabase environment variables not properly configured!');
  console.error('Please set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in your environment.');
}

// Create singleton Supabase client
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    // Use localStorage in browser, memory storage in Node.js
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
  },
  db: {
    schema: 'public',
  },
  global: {
    headers: {
      'X-Client-Info': 'pkks-web-app',
    },
  },
});

// Export for convenience
export default supabase;
